import { useTranslation } from "react-i18next";

import useExportAdapter from "../../../hooks/useExportAdapter";

import {
  ExportItem,
  ExportList,
  ExportTextTitle,
  ExportWrapper,
} from "./Export.styled";

const Export = ({ txtData, exportData }) => {
  const { t } = useTranslation();

  const { exportToExcel, exportToTxt, exportToUrl } = useExportAdapter(
    txtData,
    exportData,
  );

  return (
    <ExportWrapper>
      <ExportTextTitle>{t("global.export")}:</ExportTextTitle>

      <ExportList>
        <ExportItem onClick={exportToTxt} data-testing-id="export-to-txt">
          txt
        </ExportItem>
        <ExportItem onClick={exportToExcel} data-testing-id="export-to-excel">
          excel
        </ExportItem>
        <ExportItem onClick={exportToUrl} data-testing-id="export-to-url">
          url
        </ExportItem>
      </ExportList>
    </ExportWrapper>
  );
};

export default Export;
